module.exports = __webpack_public_path__ + "static/media/npmmLand.afa0ead8.PNG";